import { FunctionComponent } from 'react'
import styled from 'styled-components'

import Spacer from 'components/Spacer'

const GradientContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(94.69deg, #07bff1 13.43%, #1299ec 85.54%);
  padding: 32px;
  color: ${props => props.theme.colors.white};
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    padding: 48px 0;
  }
  @media (min-width: ${props => props.theme.metrics.desktopLarge}px) {
    padding: 82px 0;
  }
`

const Container = styled.div`
  width: 100%;
  display: flex;
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    max-width: 880px;
  }
  @media (min-width: ${props => props.theme.metrics.desktopLarge}px) {
    max-width: ${props => props.theme.metrics.contentMaxWidth}px;
  }
`

const Header = styled.div`
  font-size: 36px;
  font-weight: 800;
  text-align: center;
  line-height: 49px;
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    font-size: 44px;
    line-height: 60px;
    text-align: left;
    max-width: 300px;
  }
`

const LayoutContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    flex-direction: row;
    align-items: center;
  }
`

const ResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: no-wrap;
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    row-gap: 44px;
  }
`

const ResultWrapper = styled.div`
  padding: 0;
  margin: 0;
`

const DataText = styled.div`
  font-size: 44px;
  font-weight: 500;
  text-align: center;
  line-height: 60px;
  letter-spacing: 1px;
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    font-size: 52px;
    line-height: 71px;
    text-align: left;
  }
`

const InfoText = styled.div`
  font-size: 16px;
  font-weight: 300;
  line-height: 22px;
  letter-spacing: 0.346px;
  color: ${props => props.theme.colors.blue11};
  text-align: center;
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    text-align: left;
  }
`

const ResultsA: FunctionComponent = () => (
  <GradientContainer>
    <Container>
      <LayoutContainer>
        <Header>Our numbers speak for themselves.</Header>
        <Spacer
          size={36}
          tabletSize={40}
          desktopSize={24}
          desktopLargeSize={16}
        />
        <ResultsContainer>
          <ResultWrapper>
            <DataText>3,750</DataText>
            <InfoText>Homes Sold</InfoText>
          </ResultWrapper>
          <Spacer
            size={16}
            desktopSize={48}
            desktopLargeSize={48}
          />
          <ResultWrapper>
            <DataText>$1.9 Billion</DataText>
            <InfoText>Total Transactions</InfoText>
          </ResultWrapper>
          <Spacer
            size={16}
            desktopSize={48}
            desktopLargeSize={48}
          />
          <ResultWrapper>
            <DataText>$21,000</DataText>
            <InfoText>Average Savings Per Sale</InfoText>
          </ResultWrapper>
          <Spacer
            size={16}
            desktopSize={48}
            desktopLargeSize={48}
          />
          <ResultWrapper>
            <DataText>9 Days</DataText>
            <InfoText>Median Time on Market</InfoText>
          </ResultWrapper>
          <Spacer
            size={16}
            desktopSize={48}
            desktopLargeSize={48}
          />
          <ResultWrapper>
            <DataText>$77.5 Million</DataText>
            <InfoText>Total Customer Savings</InfoText>
          </ResultWrapper>
          <Spacer
            size={16}
            desktopSize={48}
            desktopLargeSize={48}
          />
          <ResultWrapper>
            <DataText>4.8/5.0</DataText>
            <InfoText>Zillow &amp; Trust Pilot Ratings</InfoText>
          </ResultWrapper>
        </ResultsContainer>
      </LayoutContainer>
    </Container>
  </GradientContainer>
)

export default ResultsA
